const sxStyles = {
    name: {
        display: "block",
        color: "#FEFEFF"
    },
    desc: {
        color: "#BCC2C4"
    },
    tooltipText: {
        whiteSpace: "wrap",
        textOverflow: "ellipsis"
    }
};

export default sxStyles;
